import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // Required for OAuth redirects
  },
  realtime: {
    timeout: 20000,
    params: {
      eventsPerSecond: 10,
    },
    autoconnect: true,
    broadcast: { ack: true },
  },
});

// Helper for error handling
export const handleSupabaseError = error => {
  console.error('Supabase error:', error.message);
  return error;
};
